const defaultNewTenantForm = {
    id: '',
    name: '',
    selling_companies: [],
    groups: [],
    signature: null,
    client_view_mode: 'SHARED',
    enforce_mfa: false,
    type: '',
    email: '',
}

export default defaultNewTenantForm;